// QR renderer for the rotating venue token (§6.2).
//
// CDN-free, ZERO new dependency. The customer web app has no QR *render* library
// (`html5-qrcode` in package.json is a camera *scanner*), so rather than add a
// build-time dep that would require `npm install` before the staff link works, we
// ship a small, self-contained inline encoder (./qrcode + ./QrCanvas). It renders
// to a <canvas> on any phone browser with nothing to install.
//
// Capacity note: the inline encoder covers QR versions up to ~v10 (≈230 bytes),
// which is ample for a compact rotating venue token or a short /q/<token> URL. If
// a payload ever exceeds that, QrCanvas renders a readable notice instead of
// crashing (fail-safe). If the backend ever emits a very long signed token, swap
// this single file to `qrcode.react`'s <QRCodeCanvas/> (add the dep) — the rest of
// the staff tool is unaffected.
import React from 'react';
import QrCanvas from './QrCanvas';

export default function QrImage({ value, size = 232 }) {
  if (!value) {
    return <div className="staff-qr-fallback">No active token yet.</div>;
  }
  return <QrCanvas value={value} size={size} />;
}
